const styles = {
    alert: theme => ({
        '&.MuiAlert-outlined': { borderColor: theme.palette.color.primary, },
        '& .MuiAlert-message': { overflow: 'visible', },
        color: theme.palette.text.primary,
        fontFamily: '"Open Sans", sans-serif',
        fontSize: '.875rem',
        [theme.breakpoints.down('md')]: {
            padding: '12px 20px 3px',

            '& .MuiAlert-icon': { display: 'none', },
        }
    }),
    alertIcon: theme => ({
        color: theme.palette.color.primary,
        height: '.8em',
        width: '.8em',
    }),
    alertIconMobile: theme => ({
        ...styles.alertIcon(theme),
        mr: '10px',
    }),
    alertTitle: theme => ({
        color: theme.palette.color.primary,
        fontWeight: 'bold',
        fontSize: '.875rem',
    }),
    checkbox: theme => ({
        '&.Mui-checked': {
            color: theme.palette.color.primary,
            borderColor: theme.palette.color.primary
        },
    }),
    checkboxLabel: (theme, isMultiLine) => ({
        mb: 0,
        overflow: 'visible',
        alignItems: isMultiLine ? 'flex-start' : 'center',
        '& .MuiFormControlLabel-label': {
            fontWeight: 'bold',
            fontSize: '.875rem',
            color: theme.palette.text.primary,
            pt: isMultiLine ? '9px' : 0,
            [theme.breakpoints.down('md')]: {
                mb: isMultiLine? '9px' : 0,
            }
        }
    }),
};

export default styles;